import { StyleSheet } from 'react-native'
import { Theme } from '@theme'

export default (theme: Theme) =>
  StyleSheet.create({
    body: {
      flex: 1,
      paddingHorizontal: theme.spacing.xl,
    },
    listWrapper: {
      flex: 1,
    },
    // Subtle dim while a tab switch / push refetch loads the next list.
    listLoading: {
      opacity: 0.55,
    },
    listContent: {
      flexGrow: 1,
      paddingTop: theme.spacing.xs,
      paddingBottom: theme.spacing.xxl,
    },
    sectionHeader: {
      textTransform: 'uppercase',
      letterSpacing: 0.5,
      marginTop: theme.spacing.sm,
      marginBottom: theme.spacing.md,
    },
    footerLoader: {
      marginVertical: theme.spacing.lg,
    },
  })
